export default "__VITE_ASSET__DlJP5Hq4__"